import { render, staticRenderFns } from "./q5.vue?vue&type=template&id=68626497"
import script from "./q5.vue?vue&type=script&lang=js"
export * from "./q5.vue?vue&type=script&lang=js"
import style0 from "./q5.vue?vue&type=style&index=0&id=68626497&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports